import BookPackageIcon from '../../../assets/svg/book-package.svg'
import ContextMenu from '../../../components/ui/ContextMenu'
import { MODALS, useModal } from '../../../context/ModalProvider'
import { useNav } from '../../../hooks/useNav'
import { PATH } from '../../../data/router_path'
import { setLocalStorage } from '../../../utils/localStorage'
import { BOOKS_PACKAGE_STORAGE_KEY } from '../../../data/constants'
import { getCurrentTimeKey } from '../../../utils/book_common'

export default function BookPackage({
  uuid,
  name,
  userGroupCount,
  bookCount,
  setCurrentBookPackage,
}) {
  const { handleOpenModal } = useModal()
  const navigate = useNav()
  const menuItems = [
    {
      label: 'Chỉnh sửa',
      onClick: () => {
        setCurrentBookPackage({ uuid, name })
        handleOpenModal(MODALS.EDIT_BOOK_PACKAGE)
      },
      className: '',
    },
    {
      label: 'Phân quyền',
      onClick: () => {
        setCurrentBookPackage({ uuid, name })
        handleOpenModal(MODALS.PERMISSION_BOOK_PACKAGE)
      },
      className: '',
    },
    {
      label: 'Xóa gói sách',
      onClick: () => {
        setCurrentBookPackage({ uuid, name })
        handleOpenModal(MODALS.DELETE_BOOK_PACKAGE)
      },
      className: 'text-red-600',
    },
  ]
  const handleRedirectBook = () => {
    const bookPackagePayload = {
      time: getCurrentTimeKey(),
      uuid: uuid,
    }
    setLocalStorage(
      BOOKS_PACKAGE_STORAGE_KEY.BOOK_PACKAGE_UUID,
      bookPackagePayload
    )
    navigate(PATH.BOOK.PACKAGE_BOOKS(uuid))
  }
  return (
    <div className="relative border-b border-gray-secondary py-4">
      <div className="relative flex items-center">
        <div
          className="relative mr-3 cursor-pointer flex-shrink-0"
          onClick={handleRedirectBook}
        >
          <img
            src={BookPackageIcon}
            alt="Book Package Icon"
            style={{ width: '8rem' }}
          />
          <span className="absolute left-4 top-6 flex h-6 w-6 items-center justify-center rounded-md border border-gray-secondary bg-white text-sm font-bold text-black">
            {bookCount}
          </span>
        </div>

        <div className="flex flex-1 items-center min-w-0">
          <div className="flex flex-col justify-center w-full">
            <h3
              className="cursor-pointer text-lg font-semibold hover:underline truncate"
              onClick={handleRedirectBook}
              title={name}
            >
              {name}
            </h3>
            <p className="text-sm text-gray-500">
              {userGroupCount} nhóm truy cập
            </p>
          </div>
        </div>
        <div className="absolute right-0 top-0">
          <ContextMenu menuItems={menuItems} />
        </div>
      </div>
    </div>
  )
}
